import React from 'react';
import { assest } from '../../Assest/Assest';

function RootCanals() {
  return (
    <div style={styles.container}>
      <img 
        src={assest.RootCanals} 
        alt="Root Canals" 
        style={styles.image} 
      />
      <div style={styles.content}>
        <h2 style={styles.title}>Effective and Gentle Root Canal Treatment</h2>
        <p style={styles.text}>
          A root canal is a highly effective treatment designed to save a tooth that has been damaged by severe decay or infection. 
          During the procedure, the infected pulp inside the tooth is carefully removed, the interior is cleaned and disinfected, 
          and the tooth is sealed to prevent further damage.
        </p>
        <p style={styles.text}>
          Modern root canal treatments are virtually painless and can often be completed in just one or two visits. They provide 
          relief from pain and sensitivity while preserving the natural tooth, helping you maintain your smile and oral function.
        </p>
        <p style={styles.text}>
          At our clinic, we use advanced tools and techniques to ensure your comfort and deliver excellent results. Don’t let 
          tooth pain disrupt your life—book a consultation today to see how root canal therapy can help restore your dental health.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  image: {
    width: '100%',
    maxWidth: '800px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
  },
  content: {
    marginTop: '30px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2e2e2e',
    fontWeight: '700',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    color: '#555',
    lineHeight: '1.7',
    maxWidth: '800px',
    margin: '0 auto',
    paddingBottom: '10px',
    transition: 'color 0.3s ease-in-out',
  },
};

export default RootCanals;
